"use client"
import clsx from "clsx"

export function SectionLink(props: {
  id: string
  children: React.ReactNode
  color: string
}) {
  return (
    <a
      href={`#${props.id}`}
      onClick={(e) => {
        e.preventDefault()
        document
          .getElementById(props.id)
          ?.scrollIntoView({ behavior: "smooth" })
      }}
      className={clsx([
        "relative h-[20vw] w-[25vw] rounded-lg border border-black/5 p-6 font-suisse uppercase leading-none tracking-[-0.04em] text-black shadow-sm transition-shadow duration-300 hover:shadow-lg sm:text-3xl xl:text-[clamp(28px,3.45vw,64px)] 2xl:text-5xl",
        `bg-${props.color}`,
      ])}
    >
      {props.children}
    </a>
  )
}
